import * as Sentry from '@sentry/remix';
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from '@remix-run/react';
import { startTransition, StrictMode, useEffect } from 'react';
import { hydrateRoot } from 'react-dom/client';

// Sentry Setup
if (window.ENV && window.ENV.PUBLIC_SENTRY_DSN) {
  Sentry.init({
    dsn: window.ENV.PUBLIC_SENTRY_DSN,
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,

    integrations: [
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches
      }),
      // Replay is only available in the client
      // eslint-disable-next-line import/namespace
      Sentry.replayIntegration(),
      // 以下の問題で eslint エラーになるが、実行に問題がなさそうなので eslint-disable-next-line で無効化する暫定対応。
      // - 'replayIntegration' not found in imported namespace 'Sentry' (Nextjs) · Issue #12706 · getsentry/sentry-javascript https://github.com/getsentry/sentry-javascript/issues/12706
      // - eslint(import/namespace): error 'BrowserTracing' not found in imported namespace 'Sentry' · Issue #9728 · getsentry/sentry-javascript https://github.com/getsentry/sentry-javascript/issues/9728
      // - eslint(import/namespace): error 'BrowserTracing' not found in imported namespace 'Sentry' · Issue #2969 · import-js/eslint-plugin-import https://github.com/import-js/eslint-plugin-import/issues/2969
    ]
  });
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  );
});